import { Space, Spin } from 'antd'
import { Main } from 'components/ActionStyles/ActionStyles'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import Flex from 'components/Flex'
import FileReader from 'components/Uploader/FileReader'
import Uploadloader from 'components/Uploader/Uploader'
import Download from 'components/icons/Download'
import {
  BoldText,
  InfoSection,
  LightText,
  SampleDocContainer,
} from 'modules/Students/Partials/StudentsBulkUpload/Style/style'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { SmallButtons } from '../../../components/Uploader/Styles'
import BellIcon from '../../../components/icons/BellIcon'
import ConflictUpload from '../../../components/icons/ConflictUpload'
import DullIcon from '../../../components/icons/DullIcon'
import SmileIcon from '../../../components/icons/SmileIcon'
import { env } from '../../../utils/const'
import { FolderSpinner } from '../../Placement/style'
import {
  ConflictFlex,
  ConflictInnerContent,
  ConflictInnerFlex,
  FileError,
} from '../style'
const AlertFlex = styled(Flex)`
  background: ${COLORS.BLUR_T_90};
  border: 1px solid ${COLORS.BLUR_T_95};
  border-radius: 10px;
  padding: 10px;
  margin: 15px 0;
  gap: 12px;
`

const TextWrapper = styled(Flex)`
  padding-left: 12px;
  margin-bottom: 5px;
`
const SubTextWrapper = styled(Flex)`
  padding-left: 20px;
  line-height: initial;
  align-items: baseline;
`
const ResultWrapper = styled(Flex)`
  line-height: initial;
  align-items: center;
  gap: 3px;
`
const StyledH2 = styled.h2`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 120%;
  padding-top: 10px;
  margin-left: 9px;
`
const Cirlcle = styled.div`
  padding: 4px;
  background: #4d566e;
  border-radius: 50% !important;
  margin-right: 9px;
`

const StyledP = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #4d566e;
  padding-top: 5px;
  line-height: initial;
  width: 100%;
`
const ResultUploader = ({
  roleId,
  bulkUpload,
  progress,
  setFailed,
  failed,
  bulkUploadResult,
  finalUpload,
  setFinalUpload,
  stage,
  openDrawer,
  isLoading,
  setIsLoading,
  handleResolveConflict,
  handleUploadClick,
  conflictStatus,
  candidates,
  file,
  setFile,
  bulkUploadError,
}) => {
  const [isUploaded, setIsUploaded] = useState(false)
  const onFileUploaded = file => {
    setFile(file)
    if (file?.url) {
      bulkUpload(file?.url)
    }
    setFailed(false)
    setFinalUpload(0)
  }

  useEffect(() => {
    if (openDrawer) {
      setFile()
    }
  }, [openDrawer])

  const isFinalUpload = value => {
    setFinalUpload(finalUpload + value)
  }

  const UploadedData = [
    {
      name: 'Upload Offer Issued Students',
      content: 'Upload result in Excel sheet',
      status: 'RELEASED',
    },
    {
      name: 'Upload Offer Accepted Students',
      content: 'Upload result in Excel sheet',
      status: 'ACCEPTED',
    },
  ]
  let currentTime = new Date().getTime()
  const downloadURI = () => {
    let uri =
      env.STUDENT_ATS_TEMPLATE ||
      'https://d18zc7o1u7b8o7.cloudfront.net/students/bulkupload/StudentAtsResultTemplate.xlsx'
    let name = 'SampleDoc'
    let link = document.createElement('a')
    link.download = name
    link.href = uri
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
  return (
    <>
      {conflictStatus === '' && stage === 'offer' ? (
        UploadedData.map(item => {
          return (
            <ConflictFlex onClick={() => handleUploadClick(item.status)}>
              <ConflictUpload />
              <ConflictInnerFlex>
                <ConflictInnerContent disable={true}>
                  {item.name}
                </ConflictInnerContent>
                <ConflictInnerContent>{item.content}</ConflictInnerContent>
              </ConflictInnerFlex>
            </ConflictFlex>
          )
        })
      ) : (
        <>
          <InfoSection>
            <Space>
              <SmallButtons
                height={'30px'}
                width="30px"
                border={true}
                icon={<Download />}
              />
              <SampleDocContainer>
                <BoldText>Candidate Sample Doc</BoldText>
                <LightText>To Upload bulk upload data, use template</LightText>
              </SampleDocContainer>
            </Space>
            <Main>
              <Button.Secondary
                onClick={downloadURI}
                trigger={['click']}
                text="Download"
              ></Button.Secondary>
            </Main>
          </InfoSection>
          {!file && (
            <Uploadloader
              setFile={onFileUploaded}
              isDefault={true}
              fileName={`Evaluation_Result_${roleId}_${currentTime}`}
              format={' (.xlsx, .csv)'}
              setIsLoading={setIsLoading}
            />
          )}
          {isLoading ? (
            <FolderSpinner style={{ marginTop: '3rem' }}>
              <Spin small tip="Loading" size="large" />
            </FolderSpinner>
          ) : (
            <>
              {file && (
                <FileReader
                  file={{
                    ...file,
                    name: 'Evaluation_Result',
                  }}
                  setFile={onFileUploaded}
                  setIsUploaded={setIsUploaded}
                  isUploaded={isUploaded}
                  isLoader={true}
                  progress={progress}
                  failed={failed}
                />
              )}
              {!file && (
                <AlertFlex>
                  <Control column top="2px" bottom="2px">
                    <TextWrapper alignCenter>
                      <>
                        {' '}
                        <BellIcon />{' '}
                        <StyledH2 alignCenter> Please note!</StyledH2>
                      </>
                    </TextWrapper>
                    <SubTextWrapper>
                      <Cirlcle />
                      <StyledP>
                        {stage === 'offer'
                          ? `Upload only the offer ${
                              conflictStatus === 'RELEASED'
                                ? 'issued'
                                : 'accepted'
                            } students!`
                          : 'Upload only the shortlisted Candidates.'}
                      </StyledP>
                    </SubTextWrapper>
                    <SubTextWrapper>
                      <Cirlcle />
                      <StyledP>
                        Providing the student's email ID is mandatory.
                        Additionally, either the student's name or contact
                        number is mandatory
                      </StyledP>
                    </SubTextWrapper>
                  </Control>
                </AlertFlex>
              )}
              {file && Object?.keys(bulkUploadResult)?.length !== 0 && (
                <Control column top="40px" bottom="2px">
                  {Number(bulkUploadResult?.data?.matchedCandidateIds?.length) >
                  0 ? (
                    <ResultWrapper alignCenter>
                      <SmileIcon />
                      <StyledH2>
                        {Number(
                          bulkUploadResult?.data?.matchedCandidateIds?.length
                        )}
                        &nbsp;student
                        {bulkUploadResult?.data?.matchedCandidateIds?.length > 1
                          ? 's'
                          : ''}
                        {Number(
                          bulkUploadResult?.data?.matchedCandidateIds?.length
                        ) > 1
                          ? ' are '
                          : ' is '}
                        successfully shortlisted.
                      </StyledH2>
                    </ResultWrapper>
                  ) : (
                    <ResultWrapper alignCenter>
                      <DullIcon />
                      <StyledH2>
                        No candidates match for the above sheet
                      </StyledH2>
                    </ResultWrapper>
                  )}
                  {Number(bulkUploadResult?.data?.conflictCandidates?.length) >
                    0 && (
                    <>
                      <ResultWrapper alignCenter>
                        <DullIcon />
                        <StyledH2>
                          <>{'Status conflict with '}</>
                          {bulkUploadResult?.data?.conflictCandidates?.length}
                          {bulkUploadResult?.data?.conflictCandidates?.length >
                          1
                            ? ' students'
                            : ' student'}
                        </StyledH2>
                      </ResultWrapper>
                      {bulkUploadResult?.data?.conflictCandidates?.length !==
                        0 && (
                        <Control column top="10px">
                          <Button.Danger
                            wordBreak
                            text={'Resolve Conflicts'}
                            width="max-content"
                            onClick={() => handleResolveConflict()}
                          />
                        </Control>
                      )}
                    </>
                  )}
                  {conflictStatus !== 'RELEASED' &&
                    finalUpload !== -1 &&
                    finalUpload !== 2 &&
                    bulkUploadResult?.data?.rejectionCandidateIds?.length !==
                      0 && (
                      <Control column top="30px">
                        {finalUpload == 0 && (
                          <StyledP>
                            Is this the last batch you are uploading?
                          </StyledP>
                        )}
                        {finalUpload > 0 && (
                          <StyledP>
                            {stage === 'offer' || conflictStatus === 'ACCEPTED'
                              ? `Do you want to mark all the other students as “Offer
                declined”`
                              : `Do you want to reject the other candidates who weren't selected?`}
                          </StyledP>
                        )}

                        <Control top="8px" gap="5%">
                          <Button.Secondary
                            text="No"
                            onClick={() => isFinalUpload(-1)}
                          />
                          <Button.Primary
                            text="Yes"
                            onClick={() => isFinalUpload(+1)}
                          />
                        </Control>
                      </Control>
                    )}
                </Control>
              )}
              {file && Object?.keys(bulkUploadResult)?.length === 0 && (
                <FileError>{bulkUploadError}</FileError>
              )}
            </>
          )}
        </>
      )}
    </>
  )
}

export default ResultUploader
